module.exports = __webpack_public_path__ + "static/media/CloseIcon_Light.2209faf4.svg";